<div class="main_Hero1 align-items-center">
    <div class="Hero">
        <div class="container min-vh-100 d-flex align-items-center">
            <div class="row heroContent align-items-center">

                <!-- Left Column -->
                <div class="col-md-6 mb-4 mb-md-0">
                    <div class="hero-logo mb-4">
                        <img src="assets/images/Logo.svg" alt="Nishwik Logo">
                    </div>
                    <div class="main-content">
                        <h6>INDIA’S FIRST HYBRID</h6>
                        <h2>Finance, Property, Freedom<br>Together.</h2>
                        <p>Get home loans, school EMIs, instant credit, and goal-based savings— all in one seamless and
                            powerful app experience.</p>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                    <div class="login-box px-4 pt-0 pb-4">
                        <!-- Tabs Header -->
                        <div class="">
                            <ul class="nav nav-tabs custom-tabs mb-3" id="accountTabs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="user-tab" data-bs-toggle="tab"
                                        data-bs-target="#user" type="button" role="tab">
                                        Individual
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="business-tab" data-bs-toggle="tab"
                                        data-bs-target="#business" type="button" role="tab">
                                        Business
                                    </button>
                                </li>
                            </ul>





                            <!-- Tab Content -->
                            <div class="tab-content" id="accountTabsContent">
                                <!-- User Form -->
                                <div class="tab-pane fade show active" id="user" role="tabpanel">

                                    <h2>Create Your Nishwik Account</h2>

                                    <form>
                                        <!-- Aadhaar / PAN -->
                                        <div class="form-group row align-items-center mb-4">
                                            <div class="col-md-12">

                                                <div class="d-flex align-items-center flex-wrap w-100">
                                                    <div class="flex-fill me-3">
                                                        <label for="aadhaar">Aadhaar Card Number</label>
                                                        <input type="text" id="aadhaar" class="form-control"
                                                            placeholder="1234 5678 9012"
                                                            [formControl]="userMasterForm.controls['aadharNumber']">
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('aadharNumber')?.hasError('duplicate')">
                                                            This Aadhar Number is already registered with another
                                                            account.
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.hasError('atLeastOneRequired') && userMasterForm.touched">
                                                            Please enter either Aadhaar or PAN number.
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('aadharNumber')?.touched && userMasterForm.get('aadharNumber')?.hasError('pattern')">
                                                            Aadhaar number must be 12 digits and cannot start with 0 or
                                                            1.
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('aadharNumber')?.touched && (userMasterForm.get('aadharNumber')?.hasError('minlength') || userMasterForm.get('aadharNumber')?.hasError('maxlength'))">
                                                            Aadhaar number must be exactly 12 digits.
                                                        </small>
                                                    </div>

                                                    <p class="mb-0 fw-bold text-center text-danger px-2">OR</p>

                                                    <div class="flex-fill ms-3">
                                                        <label for="pan">PAN Number</label>
                                                        <input type="text" id="pan" class="form-control"
                                                            placeholder="ABCDE1234F"
                                                            [formControl]="userMasterForm.controls['panNumber']">
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('panNumber')?.hasError('duplicate')">
                                                            This PAN Number is already registered with another
                                                            account.
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.hasError('atLeastOneRequired') && userMasterForm.touched">
                                                            Please enter either Aadhaar or PAN number.
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('panNumber')?.touched && userMasterForm.get('panNumber')?.hasError('pattern')">
                                                            Enter a valid PAN number (e.g., ABCDE1234F).
                                                        </small>
                                                        <small class="error text-danger"
                                                            *ngIf="userMasterForm.get('panNumber')?.touched && (userMasterForm.get('panNumber')?.hasError('minlength') || userMasterForm.get('panNumber')?.hasError('maxlength'))">
                                                            PAN number must be exactly 10 characters.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Name Fields -->
                                        <div class="form-group row mb-4">
                                            <div class="col-md-4">
                                                <label for="fname">First Name <span class="text-danger">*</span></label>
                                                <input type="text" id="fname" placeholder="First Name"
                                                    [formControl]="userMasterForm.controls['firstName']">
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('firstName')?.touched && userMasterForm.get('firstName')?.hasError('required')">
                                                    First name is required.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('firstName')?.touched && userMasterForm.get('firstName')?.hasError('pattern')">
                                                    First name must contain only letters and spaces.
                                                </small>
                                            </div>
                                            <div class="col-md-4">
                                                <label for="mname">Middle Name</label>
                                                <input type="text" id="mname" placeholder="Middle Name"
                                                    [formControl]="userMasterForm.controls['middleName']">
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('middleName')?.touched && userMasterForm.get('middleName')?.hasError('pattern')">
                                                    Last name must contain only letters and spaces.
                                                </small>
                                            </div>
                                            <div class="col-md-4">
                                                <label for="lname">Last Name <span class="text-danger">*</span></label>
                                                <input type="text" id="lname" placeholder="Last Name"
                                                    [formControl]="userMasterForm.controls['lastName']">
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('lastName')?.touched && userMasterForm.get('lastName')?.hasError('required')">
                                                    Last name is required.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('lastName')?.touched && userMasterForm.get('lastName')?.hasError('pattern')">
                                                    Last name must contain only letters and spaces.
                                                </small>
                                            </div>
                                        </div>


                                        <div class="form-group row mb-4">
                                            <div class="col-md-6">
                                                <label>Date of birth <span>*</span></label>
                                                <input type="date" [formControl]="userMasterForm.controls['dob']"
                                                    [class.is-invalid]="userMasterForm.get('dob')?.touched && userMasterForm.get('dob')?.invalid" />
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('dob')?.touched && userMasterForm.get('dob')?.hasError('required')">
                                                    Date of birth is required.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('dob')?.touched && userMasterForm.get('dob')?.hasError('notTodayOrFuture')">
                                                    Date of birth cannot be today or in the future.
                                                </small>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Gender <span>*</span></label>
                                                <select class="form-select ng-pristine ng-invalid ng-touched" [formControl]="userMasterForm.controls['gender']"
                                                    [class.is-invalid]="userMasterForm.get('gender')?.touched && userMasterForm.get('gender')?.invalid">
                                                    <option value="" disabled>Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="other">Other</option>
                                                </select>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('gender')?.touched && userMasterForm.get('gender')?.invalid">
                                                    Gender is required
                                                </small>
                                            </div>
                                        </div>

                                        <!-- Contact + Email -->
                                        <div class="form-group row mb-4">
                                            <div class="col-md-6">
                                                <label for="contact">Contact Number <span
                                                        class="text-danger">*</span></label>
                                                <input type="tel" id="contact" placeholder="9876543210"
                                                    [formControl]="userMasterForm.controls['mobileNo']">
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('mobileNo')?.touched && userMasterForm.get('mobileNo')?.hasError('required')">
                                                    Contact number is required.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('mobileNo')?.touched && userMasterForm.get('mobileNo')?.hasError('pattern')">
                                                    Please enter a valid 10-digit mobile number (digits only, starting
                                                    with 6–9).
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('mobileNo')?.hasError('duplicate')">
                                                    This mobile number is already registered.
                                                </small>
                                            </div>
                                            <div class="col-md-6">
                                                <label for="email">Email ID <span class="text-danger">*</span></label>
                                                <input type="email" id="email" placeholder="abc@gmail.com"
                                                    [formControl]="userMasterForm.controls['emailId']">
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('emailId')?.touched && userMasterForm.get('emailId')?.hasError('required')">
                                                    Email address is required.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('emailId')?.touched && userMasterForm.get('emailId')?.hasError('pattern')">
                                                    Please enter a valid email address.
                                                </small>
                                                <small class="error text-danger"
                                                    *ngIf="userMasterForm.get('emailId')?.hasError('duplicate')">
                                                    This email is already registered with another account.
                                                </small>
                                            </div>
                                        </div>
                                        <!-- Username + Password -->
                                        <div class="form-group row mb-4" [formGroup]="userLoginForm">
                                            <!-- Username Field -->
                                            <div class="col-md-6 position-relative">
                                                <label class="form-label">Username <span
                                                        class="text-danger">*</span></label>
                                                <input type="text" autocomplete="off"
                                                    class="form-control input-with-icon"
                                                    [formControl]="userLoginForm.controls['userName']"
                                                    placeholder="Enter Username" />

                                                <!-- Spinner while checking -->
                                                <span *ngIf="isCheckingUserName"
                                                    class="spinner-grow text-primary fixed-loader" role="status"></span>

                                                <!-- Success icon -->
                                                <i *ngIf="userNameValid === true"
                                                    class="bi bi-check-circle-fill text-success fixed-icon"></i>

                                                <!-- Error icon -->
                                                <i *ngIf="userNameValid === false"
                                                    class="bi bi-x-circle-fill text-danger fixed-icon-x"></i>

                                                <!-- Validation error -->
                                                <div
                                                    *ngIf="userLoginForm.get('userName')?.invalid && userLoginForm.get('userName')?.touched">
                                                    <small class="text-danger">Username is required.</small>
                                                </div>

                                                <!-- API error -->
                                                <small class="text-danger" *ngIf="userNameError">{{ userNameError
                                                    }}</small>
                                            </div>

                                            <!-- Password Field -->
                                            <div class="col-md-6 position-relative">
                                                <label class="form-label">Password <span
                                                        class="text-danger">*</span></label>
                                                <input [type]="showPassword ? 'text' : 'password'"
                                                    autocomplete="new-password" class="form-control pr-5"
                                                    [formControl]="userLoginForm.controls['userPassword']"
                                                    placeholder="Enter Password" />

                                                <!-- Eye toggle -->
                                                <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                                                    (click)="togglePasswordVisibility()"
                                                    style="position: absolute; top: 38px; right: 20px; cursor: pointer;"></i>

                                                <!-- Validation messages -->
                                                <div
                                                    *ngIf="userLoginForm.get('userPassword')?.invalid && userLoginForm.get('userPassword')?.touched">
                                                    <small
                                                        *ngIf="userLoginForm.get('userPassword')?.hasError('required')"
                                                        class="text-danger">
                                                        Password is required.
                                                    </small>
                                                    <small
                                                        *ngIf="userLoginForm.get('userPassword')?.hasError('minlength')"
                                                        class="text-danger">
                                                        Password must be at least 6 characters long.
                                                    </small>
                                                </div>
                                            </div>


                                        </div>

                                        <button type="submit" class="login-btn w-100" (click)="submitForm()">Sign
                                            Up</button>
                                    </form>
                                </div>

                                <!-- Business Form -->
                                <div class="tab-pane fade" id="business" role="tabpanel">

                                    <h2>Businesses Made Easy with Nishwik</h2>


                                    <!-- 2x2 Grid Cards -->
                                    <div class="row g-4 mb-4">
                                        <div class="col-md-6">
                                            <div class="business-card text-center p-4 h-100 shadow-sm">
                                                <div class="icon mb-3">
                                                    <img src="assets\images\hospital.png" alt="Hospital"
                                                        class="business-icon">
                                                </div>
                                                <div class="unique-main-title">Hospital</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="business-card text-center p-4 h-100 shadow-sm">
                                                <div class="icon mb-3">
                                                    <img src="assets\images\school.png" alt="School"
                                                        class="business-icon">
                                                </div>
                                                <div class="unique-main-title">School</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="business-card text-center p-4 h-100 shadow-sm">
                                                <div class="icon mb-3">
                                                    <img src="assets\images\real.png" alt="Real Estate"
                                                        class="business-icon">
                                                </div>
                                                <div class="unique-main-title">Real Estate</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="business-card text-center p-4 h-100 shadow-sm">
                                                <div class="icon mb-3">
                                                    <img src="assets\images\Soe.png" alt="Housing Society"
                                                        class="business-icon">
                                                </div>
                                                <div class="unique-main-title">Housing Society</div>
                                            </div>
                                        </div>
                                    </div>



                                </div>


                            </div>

                            <div class="bottom-text">
                                Have an Account? <a href="/login"> Login</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>